import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KanziSalesFloormapChartService {

  percentColors: any[]=[];
  mediaPercent: number = 0.5;
  topLimitPercent: number = 1;
  constructor() {}

  colorForPercentage(
    percentage: number,
    media: number = 50,
    topLimit: number = 1
  ) {
    let i;
    percentage = percentage / 100;
    this.mediaPercent = media === 0 ? 0.5 : media / 100;
    this.topLimitPercent =
      topLimit > 100 || topLimit === 0 ? 1 : topLimit / 100;

    this.percentColors = [
      { pct: 0.0, color: { r: 0xff, g: 0x00, b: 0 } },
      { pct: this.mediaPercent, color: { r: 0xff, g: 0xff, b: 0 } },
      { pct: this.topLimitPercent, color: { r: 0x00, g: 0xff, b: 0 } },
    ];
    for (i = 1; i < this.percentColors.length - 1; i++) {
      if (percentage < this.percentColors[i].pct) {
        break;
      }
    }
    let lower = this.percentColors[i - 1];
    var upper = this.percentColors[i];
    var range = upper.pct - lower.pct;
    var rangePct = (percentage - lower.pct) / range;
    var pctLower = 1 - rangePct;
    var pctUpper = rangePct;
    var color = {
      r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
      g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
      b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper),
    };
    return `#${this.rgbToHex(color.r)}${this.rgbToHex(color.g)}${this.rgbToHex(
      color.b
    )}`;
  }

  rgbToHex(rgb:any) {
    var hex = Number(rgb).toString(16);
    if (hex.length < 2) {
      hex = '0' + hex;
    }
    return hex;
  }
}
